import { useState } from 'react';

import { useDeviceType } from '@braskai/ui-kit';

// eslint-disable-next-line boundaries/element-types
import { BurgerButton } from '@/widgets/sidebar/ui/BurgerButton';

import { RecordingMobileSidebar } from './RecordingMobileSidebar';
import { RecordingTabletSidebar } from './RecordingTabletSidebar';

type Props = {
  isAuthenticated?: boolean;
};

export const RecordingToggleSidebar = ({ isAuthenticated = true }: Props) => {
  const { isMobile, isTablet } = useDeviceType();
  const [isOpen, setIsOpen] = useState(false);

  const handleClose = () => setIsOpen(false);
  const handleOpen = () => setIsOpen(true);
  const handleToggle = () => setIsOpen((prevState) => !prevState);

  if (!isMobile && !isTablet) {
    return null;
  }

  return (
    <>
      <BurgerButton onClick={handleOpen} />
      {isTablet && <RecordingTabletSidebar isAuthenticated={isAuthenticated} isOpen={isOpen} onClose={handleClose} />}
      {isMobile && (
        <RecordingMobileSidebar isAuthenticated={isAuthenticated} isOpen={isOpen} onToggle={handleToggle} />
      )}
    </>
  );
};
